<template>
  <div class="hiw" id="how_it_works">
    <div class="hiw-title">How it works</div>
    <div class="hiw-description">A few simple steps to find out is your property over-assessed</div>

    <div class="hiw-steps">
      <div class="hiw-step" v-for="(step, index) in steps" :key="index">
        <img :src="step.icon" :alt="`icon step ${index + 1}`" />
        <div class="hiw-step-line"></div>
        <img :src="step.numberIcon" :alt="`step ${index + 1}`" />
        <div class="hiw-step-text">
          <div class="hiw-step-title">{{ step.title }}</div>
          <div class="hiw-step-description">{{ step.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enterIcon from "@/assets/enter.svg";
import findIcon from "@/assets/find.svg";
import lockIcon from "@/assets/lock.svg";
import number1Icon from "@/assets/number_1.svg";
import number2Icon from "@/assets/number_2.svg";
import number3Icon from "@/assets/number_3.svg";

export default {
  name: "HowItWorks",
  data() {
    return {
      steps: [
        {
          icon: enterIcon,
          numberIcon: number1Icon,
          title: "Enter your address",
          description:
            "Provide your property address, or block and lot number, and enter basic parameters like land area and start of construction estimate.",
        },
        {
          icon: findIcon,
          numberIcon: number2Icon,
          title: "Analyze",
          description:
            "Our system evaluates your tax incentive scenarios using proven 485x and UAP benchmarks.",
        },
        {
          icon: lockIcon,
          numberIcon: number3Icon,
          title: "Unlock Savings",
          description:
            "Receive a tailored report with actionable insights to maximize your project’s value.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.hiw {
  display: flex;
  padding: 80px 60px 120px 60px;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  align-self: stretch;
}

.hiw-title {
  color: var(--Font-navy, #0A1250);
  text-align: center;

  /* H1 */
  font-family: "Open Sans";
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
  /* 60px */
}

.hiw-description {
  color: var(--Font-navy, #0A1250);
  font-family: "Open Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.hiw-steps {
  display: flex;
  flex-direction: column;
  gap: 64px;
  max-width: 690px;
}

.hiw-step {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;

  .hiw-step-line {
      position: absolute;
      width: 1px;
      border: 1px solid #F4F8FC;
      bottom: -80px;
      top: 10px;
      left: 142px;
      z-index: -1;
    }

  &:last-of-type {
      .hiw-step-line {
        display: none;
      }
    }
}


.hiw-step-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.hiw-step-title {
  color: var(--Font-navy, #0A1250);
  font-family: "Open Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  /* 150% */
}

.hiw-step-description {
  color: #546C92;

  /* Body */
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 150% */
}
</style>
